require('./mortgageRequestExpensesProvisionView.scss');
// @ vendors
const React = require('react');
const PropTypes = require('prop-types');
const { connect } = require('react-redux');
const { formatText, getFinalTitle } = require('core/i18n').i18n;
// @ commons
const { OKHeaderSubPage } = require('commonsComponents/OKHeaderSubPage');
const { OKCover } = require('commonsComponents/OKCover');
// @ utils
const { contactCenterClassName } = require('utilities/conditionals/conditionalClassname')
// @ components
const { MortgageRequestExpensesProvision } = require('components/mortgageRequest/mortgageRequestExpenses/mortgageRequestExpensesProvision/mortgageRequestExpensesProvision');


class MortgageRequestExpensesProvisionView extends React.Component {

    render() {
        const { immGlobalPosition } = this.props;
        const isClientWithoutAccounts = immGlobalPosition.get("isClientWithoutAccounts");
        const mappingBreadcrumb = [
            {
                text: formatText('navbar-loans'),
                url: '/myprofile/loans-mortgages'
            },
            {
                text: formatText('mortgageRequestPresentation-title'),
                url: '/myprofile/mortgage/panel'
            },
            {
                text: formatText('mortgageRequestExpensesProvision-title'),
                url: ''
            }
        ].filter((config, index) => (isClientWithoutAccounts && index !== 0) || !isClientWithoutAccounts);

        const morgateClassName = contactCenterClassName('mortgage-request-expenses-provision-view__body', 'grid-view__body')
        return (
            <div className="mortgage-request-expenses-provision-view">
                <div className="container-fluid">
                    <div className="row">
                        <OKCover size="medium" section="loansmortgages" customClass="col-xs-12">
                            <OKHeaderSubPage
                                breadcrumbConfig={mappingBreadcrumb}
                                finalTitle={getFinalTitle('mortgageRequestExpensesProvision-titleHeader')}
                            />
                        </OKCover>
                    </div>
                </div>
                <div className={morgateClassName}>
                    <div className="container-fluid">
                        <div className="row grid-view--content-position-negative">
                            <div className="col-xs-12">
                                <MortgageRequestExpensesProvision />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

MortgageRequestExpensesProvisionView.propTypes = {
    immGlobalPosition: PropTypes.object.isRequired
}

module.exports.MortgageRequestExpensesProvisionView = connect(
    state => ({
        immGlobalPosition: state.globalPosition,
    }), null
)(MortgageRequestExpensesProvisionView);
